import React from "react";
import ListaModel from "./model/ListaModel";
import AppState from "./model/AppState";
import Rodape from "./components/Rodape";
import BotaoVoltar from "./components/BotaoVoltar";
import LogUtil from "./util/LogUtil";
import NavegadorUtil from "./util/NavegadorUtil";

import { ReactComponent as ImagemExcluir } from "./assets/images/icons/ico-listas-excluir.svg";
import Carregando from "./components/Carregando";
import { Link } from "react-router-dom";

type ListasExcluirState = {
  listas: ListaModel[];
  carregando: boolean;
  concluido: boolean;
};

class ListasExcluir extends React.Component<any, ListasExcluirState> {
  constructor(props: any) {
    super(props);
    this.deleteLista = this.deleteLista.bind(this);

    this.state = {
      listas: [],
      carregando: false,
      concluido: false,
    };
  }

  deleteLista(id: string): void {
    this.setState({ carregando: true });
    AppState.remLista(id)
      .then(() => {
        NavegadorUtil.alerta(this, "Lista excluída com sucesso");
        AppState.getListas().then((listas) => {
          this.setState({
            listas,
            carregando: false,
          });
        });
      })
      .catch((ex: any) => {
        NavegadorUtil.alerta(this, ex.data.exceptionMessage);
      });
  }

  componentDidMount(): void {
    LogUtil.logPage("Lista excluir");

    this.setState({
      carregando: true,
    });

    AppState.getListas().then((listas: ListaModel[]) => {
      this.setState({
        listas,
        carregando: false,
        concluido: true,
      });
    });
  }

  render(): any {
    const { listas, carregando, concluido } = this.state;

    return (
      <section className="lists">
        <div className="header">
          <BotaoVoltar titulo="Excluir listas" />
        </div>
        <ul className="arrow-list">
          {listas.map((lista: ListaModel) => (
            <li>
              <div>
                <p>{lista.nome}</p>
              </div>
              <button
                className="more"
                onClick={() => this.deleteLista(lista.listaId)}
              >
                <ImagemExcluir />
              </button>
            </li>
          ))}
          {listas.length === 0 && (
            <div className="empty-cart">
              <p>Nenhuma lista encontrada.</p>
              <p>
                <Link to={NavegadorUtil.getUrl("/listas")}>Clique aqui</Link>{" "}
                para voltar para as listas.
              </p>
            </div>
          )}
        </ul>
        <Rodape parent={this} ativo="Lista"></Rodape>
        <Carregando exibir={carregando} concluido={concluido}></Carregando>
      </section>
    );
  }
}

export default ListasExcluir;
